/* eslint-disable newline-per-chained-call */
import React, { useEffect, useState } from "react";
import JobTitleList from "components/CandidateCard/JobTitles";
import checkcircle from "../../../images/checkcircle.svg";
import primaryarrow from "../../../images/primary-arrow.svg";
import ExperienceList from "components/CandidateCard/ExperienceList";
import SkillsList from "components/CandidateCard/SkillsLIst";
import { Drawer, notification } from "antd";
import { getDate } from "utils";
import DrawerHeader from "components/CandidateCard/DrawerHeader";
import EducationList from "../../CandidateCard/EducationDetails";
import { Checkbox } from "antd";
import { Avatar, Button, Tag, Col, Space } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { setSelectedScreeningCadidateName } from "store/slices/candidateScreening";
import { useDispatch } from "react-redux";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";
import {
  replaceReduxCandidates,
} from "store/slices/candidateBulkMail.slice";
import { readUser } from "services/localStorage.service";
import TooltipWrapper from "components/CandidateProfile/TooltipWrapper";
import CustomCandidateTags from "components/CandidateCard/CustomCandidateTags";
import { useFeatureAllowedFromState } from "services/CustomeHooks";
import CandidateBioComponentNew from "components/TalentPools/CandidateBioComponentNew";
import Certificates from "components/TalentPools/Candidates/Certificates";
import CandidateBasicDetails from "./CandidateBasicDetails";
import CandidateProfile from "./CandidateProfile";

interface CandidateCardProps {
  listViewType?: string;
  candidateDetails?: any;
  shortList?: boolean;
  selectedPool?: number | null;
  isNotes?: boolean;
  handleSelectCandidate?: (id: number) => void;
  selectedCandidates: number[];
  notes?: boolean;
  searchId?: number;
  contacted?: boolean;
  isSearch?: boolean;
  isRejectedCandidate?: boolean;
  changeAllIdsSelected?: any;
  isUserProject?: boolean;
  configs?: any;
  handleShortlistCandidate?: any;
  handleRejectCandidate?: any;
}

const CandidateCard: React.FC<CandidateCardProps> = ({
  listViewType,
  candidateDetails,
  shortList,
  selectedPool,
  isNotes = false,
  handleSelectCandidate,
  selectedCandidates,
  notes = true,
  contacted,
  searchId,
  isSearch = false,
  isRejectedCandidate,
  changeAllIdsSelected,

  isUserProject,
  configs,
  handleShortlistCandidate,
  handleRejectCandidate
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showAllNotes, setShowAllNotes] = useState(false);
  const dispatch = useDispatch();
  const isFeatureAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCPV);
  const getUserInfo = readUser();
  const showDrawer = () => {
    dispatch(
      replaceReduxCandidates([
        {
          id: candidateDetails.id,
          name: candidateDetails.full_name,
          email: candidateDetails.email,
          profile: candidateDetails.profile_image_url,
          location: candidateDetails.location,
          jobTitle: candidateDetails.titles,
          graphProfileId: candidateDetails.graph_profile_id,
        },
      ])
    );

    if (isFeatureAllowed) {
      setOpen(true);
    } else {
      notification.warning({
        message: "Warning",
        description: "Feature not available for in this plan.",
      });
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleCheckboxChange = () => {
    if (handleSelectCandidate && candidateDetails?.id) {
      handleSelectCandidate(candidateDetails.id);
      if (selectedCandidates?.includes(candidateDetails.id)) {
        changeAllIdsSelected && changeAllIdsSelected(false);
      }
    }
  };

  const candidateNotes = showAllNotes
    ? candidateDetails?.notes
    : candidateDetails?.notes?.slice(0, 1);

  const handleCandidateDetails = async (candidateDetails: any) => {
    try {
      const candidateId = candidateDetails.id;
      dispatch(setSelectedScreeningCadidateName(candidateDetails.full_name));
      navigate(`/search/search-result/candidate-screening/screening-candidates/${candidateId}`, {
        state: { candidateDetails },
      });
    } catch (error) {
      console.error("Error fetching search prompts:", error);
    }
  };
  const eyeIconContent = (
    <div>
      {candidateDetails?.tags?.VIEWED?.length > 0 ? (
        candidateDetails.tags.VIEWED.map((view: any, Index: number) => (
          <div key={Index} dangerouslySetInnerHTML={{ __html: view }} />
        ))
      ) : (
        <p>No views available</p>
      )}
    </div>
  );

  const projectIconContent = (
    <div>
      {candidateDetails?.tags?.ADDED_TO_PROJECT?.length > 0 ? (
        candidateDetails.tags.ADDED_TO_PROJECT.map((view: any, Index: number) => (
          <div key={Index} dangerouslySetInnerHTML={{ __html: view }} />
        ))
      ) : (
        <p>No views available</p>
      )}
    </div>
  );

  const isContactInfoNotAllowed = isUserProject && !configs.contactInfo;
  const isBioNotAllowed = isUserProject && !configs.bio;

  const validNotes = candidateDetails?.notes?.filter(
    (note: any) =>
      note.custom_fields &&
      typeof note.custom_fields.note === "string" &&
      note.custom_fields.note.trim().length > 0
  );

  const [tooltips, setTooltips] = useState({
    name: "",
    title: "",
    location: "",
    emails: "",
    phones: "",
    other_profiles_urls: "",
    bio: "",
    experience: "",
    education_experience: "",
    web_search: "",
    document: "",
    note: "",
  });

  useEffect(() => {
    if (!candidateDetails.notes) return; // Ensure candidateNotes is not null or undefined
    const recentlyModified = candidateDetails.notes
      .filter((item: any) => item?.custom_fields?.is_edited)
      .sort(
        (a: any, b: any) =>
          new Date(b?.custom_fields?.modified_date).getTime() -
          new Date(a?.custom_fields?.modified_date).getTime()
      );

    if (recentlyModified.length === 0) return; // No modifications found

    const fields = [
      { key: "display_name", stateKey: "name" },
      { key: "title", stateKey: "title" },
      { key: "location", stateKey: "location" },
      { key: "emails", stateKey: "emails" },
      { key: "phone_numbers", stateKey: "phones" },
      { key: "other_profiles_urls", stateKey: "other_profiles_urls" },
      { key: "bio", stateKey: "bio" },
      { key: "work_experience", stateKey: "experience" },
      { key: "education_experience", stateKey: "education_experience" },
      { key: "web_search", stateKey: "web_search" },
      { key: "document", stateKey: "document" },
      { key: "note", stateKey: "note" },
    ];

    const newTooltips: any = { ...tooltips };

    fields.forEach(({ key, stateKey }) => {
      const item = recentlyModified.find((note: any) => note?.custom_fields?.[key]);
      if (item) {
        if (item.custom_fields?.modified_date) {
          const date = new Date(item.custom_fields?.modified_date).toISOString().split("T")[0];
          newTooltips[stateKey] = `${item.custom_fields.is_edited ? "Edited" : "Added"} by ${item.custom_fields.edited_by
            } on ${date}`;
        }
      }
    });
    setTooltips(newTooltips);
  }, [candidateDetails.notes]);

  return (
    <div className="flex mt-8 flex-1 border-b w-full overflow-x-hidden border-dashed border-main-border pb-5">
      <div className="flex gap-2 w-1/4 lg:w-1/3 pr-10 items-start	">
        {getUserInfo.role !== "EXTERNAL_CONTRIBUTOR" && (
          <Checkbox
            checked={selectedCandidates?.includes(candidateDetails?.id)}
            onChange={handleCheckboxChange}
          ></Checkbox>
        )}

        <CandidateBasicDetails
          listViewType={listViewType}
          showDrawer={showDrawer}
          name={candidateDetails?.full_name}
          location={candidateDetails?.location}
          score={
            candidateDetails?.interview_details && candidateDetails?.interview_details.length
              ? candidateDetails?.interview_details[0]?.match_percentage
              : null
          }
          profileImg={candidateDetails?.profile_image_url}
          linkedin_url={candidateDetails?.linkedin_url}
          mail={candidateDetails?.email}
          shortList={shortList}
          candidateId={candidateDetails?.id}
          selectedPool={selectedPool}
          tags={candidateDetails?.tags}
          selectedCandidates={selectedCandidates}
          licenses={candidateDetails?.licenses}
          npi={candidateDetails?.npi}
          isSearch={isSearch}
          candidateDetails={candidateDetails}
          isRejectedCandidate={isRejectedCandidate}
          isContactInfoNotAllowed={isContactInfoNotAllowed}
          tooltips={tooltips}
          eyeIconContent={eyeIconContent}
          searchId={searchId}
          projectIconContent={projectIconContent}
          handleShortlistCandidate={handleShortlistCandidate}
          handleRejectCandidate={handleRejectCandidate}
        />
      </div>

      <div className="w-3/4 lg:w-4/6">
        <div>

          <p className="text-fonttext-primary text-base font-semibold flex justify-between items-center gap-2">
            <span className="flex items-center gap-2">
              <TooltipWrapper text={tooltips?.title} placement="right">
                {candidateDetails?.titles}
              </TooltipWrapper>
            </span>
            {shortList &&
              candidateDetails?.interview_details?.length > 0 &&
              candidateDetails.interview_details[0]?.match_percentage && (
                <div className="flex gap-2">
                  <Button type="default" style={{ color: "green" }}>
                    <CheckCircleFilled />
                    {`${candidateDetails.interview_details[0].match_percentage ?? 0}% Fit`}
                  </Button>

                  <Button
                    onClick={() => handleCandidateDetails(candidateDetails)}
                    style={{ paddingTop: "1rem", paddingBottom: "0.9rem" }}
                    className="flex w-[131px] h-7 px-3  justify-center items-center rounded-md bg-[#079455] text-white hover:bg-[#068149] focus:outline-none focus:ring-2 focus:ring-[#079455] focus:ring-opacity-50"
                  >
                    View Result
                  </Button>
                </div>
              )}
          </p>
          <div className="pb-3">
            <JobTitleList
              jobTitles={candidateDetails?.work_experience}
              smallText={true}
            ></JobTitleList>
          </div>
          {shortList && selectedPool && !isSearch && (
            <div className="pb-3">
              <CustomCandidateTags
                tags={candidateDetails?.tags?.custom_tags}
                smallText={true}
                jobId={selectedPool}
                candidateId={candidateDetails.id}
              ></CustomCandidateTags>
            </div>
          )}

          <ul className="py-2.5 px-1.5 border-main-border border-1 border-b border-t mt-2 flex justify-start items-center gap-2.5">
            <li className=" font-bold pr-2.5 border-r border-main-border text-[#98a2b3] text-base text-sm">
              Experience:
            </li>
            <li className="flex gap-2 pr-2.5 border-r border-main-border flex-row">
              {candidateDetails?.work_experience?.length > 0 ? (
                <>
                  {" "}
                  <p className="flex items-center gap-1.5 text-text-quaternary font-medium text-base text-sm">
                    <img src={checkcircle} />
                    General:
                  </p>
                  <p className="text-text-tertiary font-semibold text-sm">
                    {" "}
                    {candidateDetails?.total_experience_str
                      ? candidateDetails?.total_experience_str

                        ?.replace("years", "yrs")

                        .replace("year", "yrs")
                        .replace("months", "m")
                        .replace("month", "m")
                      : "0"}{" "}
                  </p>
                </>
              ) : (
                ""
              )}
            </li>
            {candidateDetails?.work_experience?.length > 0 && (
              <>
                {candidateDetails?.work_experience[0].role_start_date && (
                  <li className="flex gap-2 pr-2.5 border-r border-main-border flex-row">
                    <p className="flex items-center gap-1.5 text-text-quaternary font-medium text-sm">
                      <img src={checkcircle} />
                      Current Role:
                    </p>
                    <p className="text-text-tertiary font-semibold text-sm">
                      {" "}
                      {candidateDetails?.duration_in_job_str
                        ?.replace("years", "yrs")
                        .replace("year", "yrs")
                        .replace("months", "m")
                        .replace("month", "m")}
                    </p>
                  </li>
                )}
                <li className="cursor-pointer flex gap-1.5" onClick={showDrawer}>
                  <p className="text-primary font-medium whitespace-nowrap text-sm">
                    View all +{candidateDetails?.work_experience.length} experience
                  </p>
                  <img src={primaryarrow} />
                </li>
              </>
            )}
          </ul>

          {candidateDetails?.work_experience?.length > 0 && (
            <div className="mt-5">
              <ExperienceList
                work_experience={candidateDetails?.work_experience}
                tooltips={tooltips}
              ></ExperienceList>
            </div>
          )}

          {candidateDetails?.intern_and_volunteer_experience?.length > 0 && (
            <ul className="py-2 px-1.5 border-main-border border-1 border-b border-t mt-2 flex gap-2.5">
              <li className="text-text-heading font-bold pr-2.5 border-r border-main-border text-sm">
                Internship Experience:
              </li>
              <li className="cursor-pointer flex gap-1.5" onClick={showDrawer}>
                <p className="text-primary font-medium whitespace-nowrap text-sm">
                  View all +{candidateDetails?.intern_and_volunteer_experience.length} experience
                </p>
                <img src={primaryarrow} />
              </li>
            </ul>
          )}
          {candidateDetails?.intern_and_volunteer_experience?.length > 0 && (
            <div className="mt-5">
              <ExperienceList
                work_experience={candidateDetails?.intern_and_volunteer_experience}
              ></ExperienceList>
            </div>
          )}
          <SkillsList
            skills={candidateDetails?.skills ? candidateDetails?.skills.split(",") : []}
            smallText={true}
          ></SkillsList>

          {notes && validNotes && validNotes.length > 0 && (
            <>
              <div className="mt-5 border-t border-main-border">
                <div className="flex gap-2 mt-2 px-1.5">
                  <p className="text-text-heading font-bold pe-2.5 text-sm">My Notes</p>
                </div>
                <div className="p-5 bg-[#F9FAFB] mt-1">
                  {(showAllNotes ? validNotes : validNotes.slice(0, 1)).map(
                    (note: any, index: number) => (
                      <div key={note.id || index}>
                        <p
                          className={`text-text-secondary text-sm font-normal ${validNotes.length > 1 ? "border-b py-3" : ""
                            }`}
                        >
                          <b>
                            ({getDate(note?.custom_fields?.modified_date)}):{" "}
                            {note.user.first_name + " " + note.user.last_name} :
                          </b>{" "}
                          {note.custom_fields.note}
                        </p>
                      </div>
                    )
                  )}
                  {validNotes.length > 1 && (
                    <span
                      className="text-primary cursor-pointer py-2 text-sm mt-2 inline-block"
                      onClick={() => setShowAllNotes(!showAllNotes)}
                    >
                      {showAllNotes ? "Read Less" : "Read More"}
                    </span>
                  )}
                </div>
              </div>
            </>
          )}
          {!isBioNotAllowed && (
            <CandidateBioComponentNew id={candidateDetails?.id} bio={candidateDetails.bio} />
          )}
          {candidateDetails?.education_experience.length > 0 && (
            <>
              <ul className="py-2 px-1.5 border-main-border border-1 border-b border-t mt-2 flex gap-2.5">
                <li className="text-text-heading font-bold pr-2.5 border-r border-main-border text-sm">
                  Education:
                </li>

                <li className="cursor-pointer flex gap-1.5">
                  <p className="text-primary font-medium text-sm" onClick={showDrawer}>
                    View all +{candidateDetails?.education_experience.length} education
                  </p>
                  <img src={primaryarrow} />
                </li>
              </ul>
              <div className="mt-5">
                <EducationList
                  education_experience={candidateDetails?.education_experience}
                  isSmall={true}
                />
              </div>
            </>
          )}
          {candidateDetails?.certifications?.length > 0 && (
            <Certificates certificates={candidateDetails?.certifications} />
          )}
        </div>
      </div>

      {isFeatureAllowed && (
        <Drawer
          placement="right"
          width="50%"
          onClose={onClose}
          open={open}
          extra={
            <DrawerHeader
              candidateDetails={candidateDetails}
              candidateId={candidateDetails?.id}
              selectedPool={selectedPool}
              isUserProject={isUserProject}
              configs={configs}
            />
          }
        >
          <CandidateProfile
            open={open}
            clickedProfile={candidateDetails?.id}
            isUserProject={isUserProject}
            configs={configs}
            isBioNotAllowed={isBioNotAllowed}
            isContactInfoNotAllowed={isContactInfoNotAllowed}
          />
        </Drawer>
      )}
    </div>
  );
};

export default React.memo(CandidateCard);
